import { _breakP } from './utils.js';
export default class tab {
  constructor() {
    this.generalTabFunc();
  }

  generalTabFunc() {
    const $tabBlock = document.querySelectorAll('.js-tabWrap'),
      deviceEvent = _breakP.SP ? 'touchstart' : 'click';

    if ($tabBlock.length) {
      $tabBlock.forEach(elm => {
        const $tabBtn = elm.querySelectorAll('.js-tabBtn'),
          $tabBtnParent = elm.querySelectorAll('.js-tabBtnWrap'),
          $tabItem = elm.querySelectorAll('.js-tabCont');

        $tabBtnParent.forEach((elm) => {
          const $targetBtn = elm.querySelectorAll('.js-tabBtn');

          function removeClass(i) {
            $tabItem[i].classList.remove('is-active');
            $targetBtn[i].classList.remove('is-active');
          }

          function addClass($index) {
            $tabItem[$index].classList.add('is-active');
            $targetBtn[$index].classList.add('is-active');
          }

          function removeAnimationClass(contentsArr) {
            contentsArr.forEach(elm => {
              const $saiItemList = elm.querySelectorAll('.sai-init');
              $saiItemList.forEach(elm => {
                elm.classList.remove('sai-animate');
              });
            });
          }

          $tabBtn.forEach(btnElm => {
            btnElm.addEventListener(deviceEvent, event => {
              event.preventDefault();
              const $targetParent = btnElm.closest('.js-tabBtnWrap'),
                $target = $targetParent.querySelectorAll('.js-tabBtn'),
                $index = [].slice.call($target).indexOf(btnElm);

              if (!btnElm.classList.contains('is-active')) removeAnimationClass($tabItem);
              for (let i = 0, length = $target.length; i < length; i++) {
                removeClass(i);
              }

              addClass($index);

              const rect = btnElm.closest('.js-tabWrap').getBoundingClientRect(),
                scrollTop = window.pageYOffset || document.documentElement.scrollTop,
                elmTop = rect.top + scrollTop;

              window.scrollTo({
                top: elmTop,
                behavior: 'smooth'
              });
            });
          });
        });
      });
    }
  }
}
